/**
 * StoryCover — generated typographic cover (default) or an uploaded image.
 * Portrait book-cover proportions, editorial in feel.
 */

import React from 'react';
import { cx } from '@/components/site/primitives';
import { COVER_TONES } from './constants';
import { getCoverTone, getCoverInitial } from './utils/storyHelpers';

export default function StoryCover({ story, className = '', textClassName = '' }) {
  const cover = story.cover ?? { type: 'typographic' };

  if (cover.type === 'image' && cover.image) {
    return (
      <div className={cx('relative overflow-hidden rounded-lg bg-cream', className)}>
        <img src={cover.image} alt="" className="h-full w-full object-cover" />
      </div>
    );
  }

  const tone = (cover.tone && COVER_TONES.find((t) => t.key === cover.tone)) || getCoverTone(story.id);
  const initial = getCoverInitial(story.title);

  return (
    <div
      className={cx('relative flex items-end overflow-hidden rounded-lg', className)}
      style={{ background: `linear-gradient(150deg, ${tone.from}, ${tone.to})` }}
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-4 -right-2 font-display text-[5.5rem] font-bold leading-none text-white/15"
      >
        {initial}
      </span>
      <span className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-white/10" />
      <p className={cx('relative z-10 p-3 font-display text-sm font-semibold leading-snug text-white/95 text-balance', textClassName)}>
        {story.title}
      </p>
    </div>
  );
}
